import { render, staticRenderFns } from "./crudLeadsServices.vue?vue&type=template&id=40e276c0&scoped=true&"
import script from "./crudLeadsServices.vue?vue&type=script&lang=js&"
export * from "./crudLeadsServices.vue?vue&type=script&lang=js&"
import style0 from "./crudLeadsServices.vue?vue&type=style&index=0&id=40e276c0&prod&lang=css&"
import style1 from "./crudLeadsServices.vue?vue&type=style&index=1&id=40e276c0&prod&lang=css&"
import style2 from "./crudLeadsServices.vue?vue&type=style&index=2&id=40e276c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e276c0",
  null
  
)

export default component.exports